import axios from "axios";
import { useQuery } from "react-query";
import { serverUrl } from "../nestserver";

/* -------------------------------------------------------------------------- */
/*                        Get Instructor Report                               */
/* -------------------------------------------------------------------------- */

export function useGetInstructorReport(
  { instructor_id, start_date, end_date, group },
  queryOptions = {},
) {
  async function getInstructorReport() {
    if (!start_date || !end_date) return null;

    const params = {
      instructorId: instructor_id,
      startDate: start_date,
      endDate: end_date,
      ...(group ? { group } : {}),
    };

    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
      params,
    };

    const res = await axios.get(
      `${serverUrl}/instructor-attendance/report`,
      config,
    );
    return res.data;
  }

  return useQuery(
    ["instructorReport", instructor_id, start_date, end_date, group],
    getInstructorReport,
    {
      enabled: !!(start_date && end_date),
      ...queryOptions,
    },
  );
}

/* -------------------------------------------------------------------------- */
/*                        Get Daily Summary                                   */
/* -------------------------------------------------------------------------- */

export async function fetchDailySummary(date, group) {
  if (!date) return null;

  const config = {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      "Access-Control-Allow-Origin": "*",
    },
    params: { date, ...(group ? { group } : {}) },
  };

  const res = await axios.get(
    `${serverUrl}/instructor-attendance/summary`,
    config,
  );
  return res.data;
}

export function useGetDailySummary(date, queryOptions = {}, group) {
  return useQuery(
    ["dailySummary", date, group],
    () => fetchDailySummary(date, group),
    {
      enabled: !!date,
      ...queryOptions,
    },
  );
}
